import { render, staticRenderFns } from "./GaugeWidget.vue?vue&type=template&id=60acf4fa&scoped=true&"
import script from "./GaugeWidget.vue?vue&type=script&lang=js&"
export * from "./GaugeWidget.vue?vue&type=script&lang=js&"
import style0 from "./GaugeWidget.vue?vue&type=style&index=0&id=60acf4fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60acf4fa",
  null
  
)

export default component.exports